export * from "./useScript";
